import styled from 'styled-components';
import { ButtonLink } from '../../../../components/Toolkit/Button/ButtonLink';
import { media } from '../../../../helpers/breakpoints';
import { SimpleShowMoreInline } from '../../../../components/Toolkit/SimpleShowMore/SimpleShowMoreInline';
import { Link as ToolkitLink } from '../../../../components/Toolkit/Button/Link';
import { OpenOutlineIc } from '@dsch/dd-icons';
import {
  List,
  SDealerContactLocationGoogleMapsLink,
} from '../../../../components/DealerPage/components/DealerContactDetails/DealerContactDetails';

export const ButtonShowNumber = styled(ButtonLink)`
  margin-bottom: ${({ theme }) => theme.spacing.S8};
  color: ${({ theme }) => theme.colors.WHITE}!important;
`;

export const ButtonShowEmail = styled(ButtonLink)`
  margin-bottom: ${({ theme }) => theme.spacing.M16};
`;

export const DealerInfoLogo = styled.img`
  width: ${({ theme }) => theme.spacing.L40};
  height: ${({ theme }) => theme.spacing.L40};
  border-radius: ${({ theme }) => theme.spacing.S4};

  ${media.large} {
    width: ${({ theme }) => theme.spacing.L48};
    height: ${({ theme }) => theme.spacing.L48};
  }
`;

export const GoogleReviewsScore = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  cursor: pointer;
  color: ${({ theme }) => theme.colors.GREY_DARK};
`;

export const GoogleReviewsWrapper = styled.div`
  display: flex;
  justify-content: space-between;
  ${({ theme }) => theme.fontSize.M14};
  padding-bottom: ${({ theme }) => theme.spacing.S8};
`;
export const HoursWrapper = styled.div`
  padding-bottom: ${({ theme }) => theme.spacing.S8};
`;

export const GoogleMapsWrapper = styled.div`
  position: relative;
  padding: ${({ theme }) => theme.spacing.S8};
  width: 100%;
  padding-bottom: 0;
  ${media.medium} {
    padding: ${({ theme }) => theme.spacing.M16};
  }
`;

export const GoogleMaps = styled.div<{ backgroundImage: string | null }>`
  position: relative;
  background-image: url(${({ backgroundImage }) => backgroundImage});
  background-position: center;
  background-repeat: no-repeat;
  background-size: cover;
  height: 264px;
  width: 100%;

  a {
    position: absolute;
    left: 16px;
    top: 16px;
    width: auto;
    padding: 0 ${({ theme }) => theme.spacing.M24};
  }
`;

export const GreyBackground = styled.div<{ backgroundImage: string | null }>`
  position: relative;
  margin-top: ${({ theme }) => theme.spacing.M24};
  background-image: url(${({ backgroundImage }) => backgroundImage});
  background-position: center;
  background-repeat: no-repeat;
  background-size: cover;
  height: 264px;
  a {
    position: absolute;
    left: 16px;
    top: 16px;
    width: auto;
    padding: 0 ${({ theme }) => theme.spacing.M24};
  }
`;

export const GoogleReviewDivider = styled.span`
  padding: 0 ${({ theme }) => theme.spacing.S8};
  &:after {
    width: ${({ theme }) => theme.spacing.S4};
    height: ${({ theme }) => theme.spacing.S4};
    background: ${({ theme }) => theme.colors.GREY};
    margin-left: ${({ theme }) => theme.spacing.S2};
    margin-right: ${({ theme }) => theme.spacing.S2};
    content: '';
    border-radius: 50%;
    display: block;
  }
`;

export const ContactWrapper = styled.div`
  grid-column: 2;
  > div {
    margin-bottom: ${({ theme }) => theme.spacing.M24};
  }
`;

export const SSimpleShowMoreInline = styled(SimpleShowMoreInline)`
  p {
    ${({ theme }) => theme.fontSize.M14};
    color: ${({ theme }) => theme.colors.GREY_DARK};
  }
  button {
    ${({ theme }) => theme.fontSize.M14};
  }
`;

export const ReadMore = styled.div`
  padding: ${({ theme }) => theme.spacing.M16} 0;
`;

export const SToolkitLink = styled(ToolkitLink)`
  vertical-align: bottom;
`;

export const SOpenOutlineIc = styled(OpenOutlineIc)`
  margin-left: ${({ theme }) => theme.spacing.S4};
  vertical-align: text-bottom;
`;

export const ListWrapper = styled(List)`
  background: ${({ theme }) => theme.colors.OFFWHITE};
  margin-top: ${({ theme }) => theme.spacing.M16};
  padding: ${({ theme }) => theme.spacing.S8}
    ${({ theme }) => theme.spacing.M16};
`;

export const SDealerContactLocationGoogleMapsLinkWrapper = styled(
  SDealerContactLocationGoogleMapsLink,
)`
  background: ${({ theme }) => theme.colors.OFFWHITE};
  margin-top: ${({ theme }) => theme.spacing.M16};
  a {
    padding: ${({ theme }) => theme.spacing.S8}
      ${({ theme }) => theme.spacing.M16};
  }
`;

export const Main = styled.div`
  display: grid;
  padding-top: ${({ theme }) => theme.spacing.M24};

  ${media.large} {
    grid-template-columns: 1fr 720px 1fr;
    grid-gap: ${({ theme }) => theme.spacing.L40};
  }
`;
